import {Component, PanelLifecycleContext} from 'panel';

import {Subscribable} from 'common/types/context/subscribable';

export class ReportEditorActions implements PanelLifecycleContext, Subscribable {
  private connectedComponents: Set<Component<any>> = new Set();
  private subscriptions: Array<() => void> = [];
  private titleEditorOpened = false;

  /**
   * Request the title editor be opened. Useful after Save As New
   * @param deferUntilCallbackChange Default is false. Wait until the next callback registration to fire the callback.
   * Set this to true if components are about to reload (and the current callback registration would be ineffective).
   * E.g. This helps work around how Insights reloads everything when opening a different Report
   */
  public openTitleEditor(deferUntilCallbackChange = false) {
    if (deferUntilCallbackChange || !this.onOpenTitleEditorCallback) {
      this.titleEditorOpened = true;
    } else {
      this.onOpenTitleEditorCallback();
    }
  }

  private declare onOpenTitleEditorCallback: () => void;

  public setOpenTitleEditorCallback(callback: () => void): void {
    this.onOpenTitleEditorCallback = callback;
    if (this.titleEditorOpened) {
      this.titleEditorOpened = false;
      this.onOpenTitleEditorCallback();
    }
  }

  // Panel Context lifecycle methods
  public bindToComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.add(component);
  }

  public unbindFromComponent(component: Component<any, any, any, any, any>): void {
    this.connectedComponents.delete(component);
  }

  // Subscribable impl
  subscribe(callback: () => void): this {
    this.subscriptions.push(callback);
    return this;
  }

  unsubscribe(callback: () => void): this {
    this.subscriptions = this.subscriptions.filter((subscription) => subscription !== callback);
    return this;
  }
}
